import { apiCall, http } from '../http'
import type { MessengerMessage, UploadFileResponse } from './types'

export interface GetMessageByChatParams {
    chatId: string
    limit: number
    offset: number
    projectId: string
}

export interface SendMessageParams {
    chatId: string
    message: string
    fileUrl?: string
    fileName?: string
    replyOn?: string
    projectId: string
}

/**
 * Получить сообщения чата
 */
export async function getByChat(params: GetMessageByChatParams) {
    const url = `messenger/message/by-chat`
    const { data, error } = await apiCall<MessengerMessage[]>(() =>
        http.get(url, {
            searchParams: {
                chatId: params.chatId,
                limit: params.limit.toString(),
                offset: params.offset.toString(),
                projectId: params.projectId,
            },
        })
    )
    return { data, error }
}

/**
 * Отправить текстовое сообщение
 */
export async function sendMessage(params: SendMessageParams) {
    const url = `messenger/message/send`
    const { data, error } = await apiCall<MessengerMessage>(() =>
        http.post(url, {
            json: {
                chatId: params.chatId,
                message: params.message,
                fileUrl: params.fileUrl,
                fileName: params.fileName,
                replyOn: params.replyOn,
                projectId: params.projectId,
            },
        })
    )
    return { data, error }
}

/**
 * Загрузить файл
 */
export async function uploadFile(params: { file: File; projectId: string }) {
    const url = `messenger/file/upload`
    const formData = new FormData()
    formData.append('file', params.file)

    const { data, error } = await apiCall<UploadFileResponse>(() =>
        http.post(url, {
            body: formData,
            searchParams: {
                projectId: params.projectId,
            },
        })
    )
    return { data, error }
}

/**
 * Отправить сообщение с файлом
 */
export async function sendWithFile(params: {
    chatId: string
    message: string
    file: File
    replyOn?: string
    projectId: string
}) {
    const url = `messenger/message/send-with-file`
    const formData = new FormData()
    formData.append('chatId', params.chatId)
    formData.append('message', params.message || '')
    if (params.replyOn) {
        formData.append('replyOn', params.replyOn)
    }
    formData.append('file', params.file)

    const { data, error } = await apiCall<MessengerMessage>(() =>
        http.post(url, {
            body: formData,
            searchParams: {
                projectId: params.projectId,
            },
        })
    )
    return { data, error }
}